module.exports = __webpack_public_path__ + "img/chevron-down.a30b9a80.svg";